<template>
  <div class="container">
    <h1>Erreur {{ error.statusCode }}</h1>
    <h1 v-if="error?.statusCode === 404">La page demandée n'existe pas</h1>
    <h1 v-else>Une erreur est apparue.</h1>
    <br />
    <h3 v-if="error?.message">{{ error.message }}</h3>
    <br />
    <br />
    <NuxtLink to="/">Accueil</NuxtLink>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['error'],
  meta: {
    isPublic: true,
  },
}
</script>
